import React from 'react';

import { TreatmentOptions } from '../components/TreatmentOptions';

export function Treatments(){
  return (
    <div>
      <h1>Treatment Options</h1>
      <TreatmentOptions />
    </div>
  );
}
